//frontend/src/components/cart/CheckoutStep.js
import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ShoppingBag, CreditCard, Check } from 'lucide-react';

const CheckoutSteps = ({ shipping, confirmOrder, payment }) => {
  // Helper function to determine step status
  const getStepStatus = (isActive, isPrevComplete) => {
    if (isActive) return 'active';
    if (isPrevComplete) return 'pending';
    return 'disabled';
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <div className="relative flex justify-between">
        {/* Connection lines */}
        <div className="absolute top-1/2 left-[15%] right-[15%] h-0.5 bg-gray-200" />
        <div 
          className="absolute top-1/2 left-[15%] h-0.5 bg-[#dc2626] transition-all duration-300"
          style={{
            right: payment ? '15%' : confirmOrder ? '50%' : shipping ? '85%' : '100%'
          }}
        />

        {/* Shipping Step */}
        <div className="relative flex-1 text-center z-10">
          <Link 
            to="/shipping"
            className={shipping ? 'pointer-events-none' : ''}
          >
            <div className={`
              mx-auto w-12 h-12 mb-2 rounded-full flex items-center justify-center
              transition-all duration-200 border-2
              ${shipping 
                ? 'bg-[#dc2626] border-[#dc2626] text-white' 
                : 'bg-white border-gray-200 text-gray-400 group-hover:border-red-200'
              }
            `}>
              {shipping ? <Check className="w-6 h-6" /> : <MapPin className="w-6 h-6" />}
            </div>
            <div className={`
              text-sm font-medium
              ${shipping ? 'text-[#dc2626]' : 'text-gray-500'}
            `}>
              Shipping
            </div>
          </Link>
        </div>

        {/* Confirm Order Step */}
        <div className="relative flex-1 text-center z-10">
          <Link 
            to="/order/confirm"
            className={`
              ${confirmOrder ? 'pointer-events-none' : ''}
              ${!shipping ? 'pointer-events-none' : ''}
            `}
          >
            <div className={`
              mx-auto w-12 h-12 mb-2 rounded-full flex items-center justify-center
              transition-all duration-200 border-2
              ${confirmOrder 
                ? 'bg-[#dc2626] border-[#dc2626] text-white'
                : shipping
                  ? 'bg-white border-gray-200 text-gray-400 hover:border-red-200'
                  : 'bg-white border-gray-200 text-gray-300'
              }
            `}>
              {confirmOrder ? <Check className="w-6 h-6" /> : <ShoppingBag className="w-6 h-6" />}
            </div>
            <div className={`
              text-sm font-medium
              ${confirmOrder 
                ? 'text-[#dc2626]' 
                : shipping 
                  ? 'text-gray-500' 
                  : 'text-gray-300'
              }
            `}>
              Confirm Order
            </div>
          </Link>
        </div>

        {/* Payment Step */}
        <div className="relative flex-1 text-center z-10">
          <Link 
            to="/payment"
            className={`
              ${payment ? 'pointer-events-none' : ''}
              ${!confirmOrder ? 'pointer-events-none' : ''}
            `}
          >
            <div className={`
              mx-auto w-12 h-12 mb-2 rounded-full flex items-center justify-center
              transition-all duration-200 border-2
              ${payment 
                ? 'bg-[#dc2626] border-[#dc2626] text-white'
                : confirmOrder
                  ? 'bg-white border-gray-200 text-gray-400 hover:border-red-200'
                  : 'bg-white border-gray-200 text-gray-300'
              }
            `}>
              {payment ? <Check className="w-6 h-6" /> : <CreditCard className="w-6 h-6" />}
            </div>
            <div className={`
              text-sm font-medium
              ${payment 
                ? 'text-[#dc2626]' 
                : confirmOrder 
                  ? 'text-gray-500' 
                  : 'text-gray-300'
              }
            `}>
              Payment
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSteps;